export enum MeetingSchedulerModalId {
  MEETING_SCHEDULER_MODAL = 'meeting-scheduler-modal'
}
